import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import { func } from "prop-types";
import { translate } from "react-i18next";
import compose from "ramda/src/compose";
import {
  Form,
  Button,
  FloatLabelInput,
  FloatLabelTextArea,
} from "shared/components";
import Loader from "../../../../../components/Loading";
import styles from "../../../styles.css";
import * as Mask from "../../../../../services/utils/mask";
import * as Validation from "../../../../../services/utils/validation";

import { createCommonIncident } from "../../../../../services/state/actions";

class InternetLinkUnavailableForm extends Component {
  onSubmit = (form) => {
    const { t, reason, createCommonIncident, onNextStep, onReset } = this.props;
    const checklist = {
      data: { ...form, reason },
      labels: {
        reason: t("MSG_0397"),
        description: t("MSG_0202"),
        internCall: t("MSG_0203"),
        problemTime: t("MSG_0217"),
        testingScheduler: t("MSG_0205"),
        contactPhone: t("MSG_0206"),
        failureDate: t("FAILURE_DATE"),
        failureTime: t("FAILURE_TIME"),
      },
    };

    return createCommonIncident(checklist, onNextStep, onReset);
  };

  renderInternCallInput = (field) => {
    const {
      meta: { touched, error, invalid },
    } = field;
    return (
      <FloatLabelInput
        id="internCall"
        name="internCall"
        onChange={field.input.onChange}
        label={field.label}
        value={field.input.value || ""}
        invalid={touched && invalid}
        error={error}
      />
    );
  };

  renderProblemTimeInput = (field) => {
    const {
      meta: { touched, error, invalid },
    } = field;
    return (
      <FloatLabelInput
        id="type"
        name="type"
        onChange={field.input.onChange}
        label={field.label}
        value={field.input.value || ""}
        invalid={touched && invalid}
        error={error}
      />
    );
  };

  renderDescriptionInput = (field) => {
    const {
      meta: { touched, error, invalid },
    } = field;
    return (
      <FloatLabelTextArea
        id="description"
        name="description"
        label={field.label}
        preset="modalTextArea"
        onChange={field.input.onChange}
        value={field.input.value || ""}
        invalid={touched && invalid}
        error={error}
        noResize
      />
    );
  };

  renderProblemTimeInput = (field) => {
    const {
      meta: { touched, error, invalid },
    } = field;
    return (
      <FloatLabelInput
        id="problemTime"
        name="problemTime"
        onChange={field.input.onChange}
        label={field.label}
        value={field.input.value || ""}
        invalid={touched && invalid}
        error={error}
      />
    );
  };
  renderTestingSchedulerInput = (field) => {
    const {
      meta: { touched, error, invalid },
    } = field;
    return (
      <FloatLabelInput
        id="testingScheduler"
        name="testingScheduler"
        onChange={field.input.onChange}
        label={field.label}
        value={field.input.value || ""}
        invalid={touched && invalid}
        error={error}
      />
    );
  };
  rendercontactPhoneInput = (field) => {
    const {
      meta: { touched, error, invalid },
    } = field;
    return (
      <FloatLabelInput
        id="contactPhone"
        name="contactPhone"
        onChange={field.input.onChange}
        maxLength="15"
        label={field.label}
        value={field.input.value || ""}
        invalid={touched && invalid}
        error={error}
      />
    );
  };

  renderInputField(field) {
    const {
      meta: { touched, error, invalid },
    } = field;

    return (
      <FloatLabelInput
        {...field.input}
        id={field.id}
        type={field.type ? field.type : "text"}
        label={field.label}
        maxLength={field.id === "contactphone" ? "15" : ""}
        invalid={touched && invalid}
        error={error}
        value={field.input.value ? field.input.value : ""}
      />
    );
  }

  renderFailureDate = () => {
    const { t } = this.props;

    return (
      <Fragment>
        <Field
          id="failureDate"
          label={t("FAILURE_DATE")}
          name="failureDate"
          component={this.renderInputField}
          normalize={Mask.date}
          format={Mask.date}
          validate={[Validation.isRequired, Validation.isValidDate]}
        />

        <Field
          id="failureTime"
          label={t("FAILURE_TIME")}
          name="failureTime"
          component={this.renderInputField}
          normalize={Mask.time}
          format={Mask.time}
          validate={[Validation.isRequired, Validation.isTime]}
        />
      </Fragment>
    );
  };

  render() {
    const {
      t,
      handleSubmit,
      submitting,
      onPreviousStep,
      failureDate,
    } = this.props;
    return (
      <Fragment>
        <Form onSubmit={handleSubmit(this.onSubmit)}>
          <p className={styles.formInstructions}>{t("MSG_0211")}</p>

          <Field
            id="description"
            name="description"
            component={this.renderDescriptionInput}
            label={t("MSG_0202")}
            validate={[Validation.isRequired]}
          />
          <Field
            id="internCall"
            name="internCall"
            component={this.renderInternCallInput}
            label={t("MSG_0203")}
            validate={[Validation.isRequired]}
          />
          {failureDate ? (
            this.renderFailureDate()
          ) : (
            <Field
              id="problemTime"
              name="problemTime"
              component={this.renderProblemTimeInput}
              label={t("MSG_0217")}
              format={Mask.time}
              validate={[Validation.isRequired, Validation.isTime]}
            />
          )}
          <Field
            id="testingScheduler"
            name="testingScheduler"
            component={this.renderTestingSchedulerInput}
            label={t("MSG_0205")}
            validate={[Validation.isRequired]}
            format={Mask.timeRange}
            normalize={Mask.timeRange}
          />
          <Field
            id="contactPhone"
            name="contactPhone"
            component={this.rendercontactPhoneInput}
            label={t("MSG_0206")}
            format={Mask.phone}
            normalize={Mask.algarPhone}
            validate={[Validation.isRequired, Validation.isPhone]}
          />
          <div className={styles.incidentModalButtons}>
            <Button onClick={onPreviousStep} relevance="low">
              {t("MSG_0292")}
            </Button>

            <Button relevance="normal" type="submit" callToAction>
              {t("MSG_0007")}
            </Button>
          </div>
        </Form>

        <Loader isOpen={submitting} />
      </Fragment>
    );
  }
}

InternetLinkUnavailableForm.propTypes = {
  onPreviousStep: func.isRequired,
  onNextStep: func.isRequired,
};

const reduxFormConfig = {
  form: "InternetLinkUnavailableForm",
};

const enhance = compose(
  translate(),
  reduxForm(reduxFormConfig),
  connect(null, { createCommonIncident })
);

export default enhance(InternetLinkUnavailableForm);



// WEBPACK FOOTER //
// ./src/components/RepairWizard/components/ModalInternetLink/Unavailable/index.js